'use strict';

import { Component, Input } from '@angular/core';

@Component({
  selector: 'menu-link',
  templateUrl: './menu-link.component.html',
  styleUrls: ['./menu-link.component.scss']
})
export class MenuLinkComponent {
  @Input() section: string;
  @Input() isSelected = false;
  @Input() external = false;
  @Input() expanded = true;

  constructor() { }

  focusSection(event) {
    event.preventDefault();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/menu-link/menu-link.component.ts